import { normalizeOrganizationRequest } from '@@utils/data';

import useTranslation from 'components/AuthChecker/hooks/useTranslation';

import useOrganizations from 'hooks/useOrganizations';

import type { OrganizationRequest } from './types';

const useCreateOrganization = () => {
    const { createOrganization } = useOrganizations();

    const { API_ERROR } = useTranslation();

    const create = async (companyName: string) => {
        const organizationData: OrganizationRequest = {
            companyName: companyName,
            location: {
                address1: '',
                city: '',
                state: '',
                zipCode: ''
            }
        };

        try {
            const result = await createOrganization(normalizeOrganizationRequest(organizationData));

            return result?.data;
        } catch (error: unknown) {
            console.error(error);
            alert(API_ERROR);
        }
    };

    const createNewOrganization = async ({ companyName }: { companyName: string }) => {
        const newOrganization = await create(companyName);

        if (newOrganization?.error) {
            console.error('[AuthChecker] Error creating organization:', newOrganization.error);

            return;
        }

        return newOrganization;
    };

    return {
        createNewOrganization
    };
};

export default useCreateOrganization;
